import React, { useState, useEffect, useMemo } from "react"


import { CardBody, Card } from "reactstrap"

import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import CommonTable from "components/Common/CommonTable"
import TimeHistory from "pages/Timesheet/TimeHistory"

const ClientTasks = ({ client_id = 0 }) => {

    const [table_data, settable_data] = useState([])
    const [loading, setLoading] = useState(false)
    const [show, setShow] = useState(false)
    const [taskData, setTaskData] = useState(null)

    useEffect(() => {
        const handleAllClientTasks = async () => {
            try {
                setLoading(true)
                const { data } = await axiosbaseurl.get(`/client/all/tasks/${client_id}`)
                if (data.success) {
                    if (data.tasks.length > 0) {
                        settable_data(data.tasks.reverse())
                    }
                }
            } catch (error) {
                console.log(error)
                swal("", error.response.data.message || "Something went Wrong", "error")
            } finally {
                setLoading(false)
            }
        }
        handleAllClientTasks()
    }, [])

    // columns

    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <div> {cellProps.row.index + 1}</div>
                },
            },
            {
                Header: "Task Name",
                accessor: "title",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Service Name",
                accessor: "serviceName.serviceName",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Period End",
                accessor: "startDate",
                disableFilters: true,
                filterable: true,
                Cell: cellProps => (<span>{new Date(cellProps.row.original?.startDate).toLocaleDateString()}</span>),
            },
            {
                Header: "Due Date",
                accessor: "dueDate",
                disableFilters: true,
                filterable: true,
                Cell: cellProps => (<span>{new Date(cellProps.row.original?.dueDate).toLocaleDateString()}</span>),
            },
            {
                Header: "Assistant",
                accessor: "assistant.name",
                disableFilters: true,
                filterable: true,
                className: " text-center",
                Cell: cellProps => (<span>
                    {cellProps.row.original.assistant
                        ? `${cellProps.row.original?.assistant?.name} ${cellProps.row.original?.assistant?.lastName}`
                        : "--"}
                </span>),
            },
            {
                Header: "Status",
                accessor: "status.statusName",
                disableFilters: true,
                filterable: true,
                className: " text-center",
                Cell: cellProps => (
                    <div className="text-center">
                        <span
                            className="badge"
                            style={{
                                color: cellProps.row.original?.status?.colorCode,
                                border: `1px solid ${cellProps.row.original?.status?.colorCode}`,
                                fontSize: "11px",
                            }}
                        >
                            {cellProps.row.original?.status?.statusName || "N/A"}
                        </span>
                    </div>
                ),
            },
            {
                Header: "Action",
                disableFilters: true,
                disableSort: true,
                accessor: "view",
                className: "text-center",
                Cell: cellProps => {
                    const { id, clientId, title, client } =
                        cellProps.row.original
                    return (
                        <>
                            <button
                                // disabled={isLoading === 'circle-notch bx-spin'}
                                onClick={() => {
                                    setShow(true)
                                    setTaskData({
                                        task: id,
                                        client: clientId,
                                        taskName: title,
                                        clientName: client.clientName,
                                    })
                                }}
                                className="btn btn-success bg-green btn-sm me-2"
                            >
                                <i className={`fas fa-list-ol`}></i>
                                {/* Logs */}
                            </button>
                        </>
                    )
                },
            },
        ],
        []
    )

    return (
        <>
            {loading && <Loader />}

            <Card className="px-0 mx-0" style={{minHeight: "70vh"}}>
                <CardBody >
                    <CommonTable
                        columns={columns}
                        data={table_data}
                        heading={"Tasks"}
                    >

                        {/* <div>
                            <button onClick={() => navigate(-1)} className="btn btn-secondary bg-dark ms-3">
                                <i className="fas fa-arrow-left me-3"></i>
                                Back
                            </button>
                        </div> */}

                    </CommonTable>
                </CardBody>
            </Card>


            <TimeHistory show={show} setShow={setShow} taskData={taskData} />

        </>
    )
}

export default ClientTasks
